export default {"src":"/_next/static/media/developers-hero-right.bcd55b8a.svg","height":397,"width":345,"blurWidth":0,"blurHeight":0};